import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'

// actions
import { getLabTypes } from "../../../store/catalogs/LabTypes/actions"
import { getLabs, updateLab, addNewLab, deleteLab, updateLabStatus } from "../../../store/catalogs/Laboratories/actions"
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types'


import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { LabRegisterModal } from './LabRegisterModal'


const CatalogLayoutLabCitecMovil = (props) => {

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    // Notification hooks
    const [visible, setIsVisible] = useState(false);

    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getLabs(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])

    const modalClose = () => {
        setIsUpdate(false)
    }

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLabTypes("?limit=4000&page=0"))
        dispatch(getLabs("?limit=20&page=0"))
    }, [])

    const { labs, loading, lab, total, currentPage, labtypes, error } = useSelector(state => ({
        labs: state.labsReducer.labs,
        loading: state.labsReducer.loading,
        lab: state.labsReducer.lab,
        error: state.labsReducer.error,
        total: state.labsReducer.total,
        currentPage: state.labsReducer.currentPage,
        labtypes: state.labType.labtypes,
    }));
    // * Redux fin
    
    const columns = React.useMemo(
        () => [
            {
                Header: 'Tipo de laboratorio',
                width: '30%',
                Cell: ({ row }) => (
                    <div >
                        {row.original.laboratoryType.name}
                    </div>
                ),
            },
            {
                Header: 'Nombre de laboratorio',
                accessor: 'name',
                width: '30%',
            },
            {
                Header: 'Estatus',
                width: '12%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const getPagination = (params) => {
        dispatch(getLabs(`${params}&search=${searchData}`))
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            setIsVisible(false)
            dispatch(updateLab(updValue))
            dispatch(updateLabStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            setIsVisible(false)
            dispatch(addNewLab(values))
        }
        setTimeout(() => {
            dispatch(getLabs("?limit=20&page=0"))
        }, 500)
        setIsVisible(true)
        setTimeout(() => {
            setIsVisible(false)
        }, 4500);
        setIsUpdate(false)
        setRowInfo('')
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteLab(rowInfo))
        setRowInfo('')
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='LabCitecMovil' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labs} />
                                </div>

                                <LabRegisterModal
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    modalRespInfo={RegisterModalRespInfo}
                                    isUpdate={isUpdate}
                                    rowInfo={rowInfo}
                                    labTypes={labtypes}
                                    modalClose={modalClose}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar tipo de laboratorio' modalBodyLabel='¿Está seguro que desea eliminar el tipo de laboratorio seleccionado?' />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />

                </Container>
            </div>
        </React.Fragment>
    )
}

export default CatalogLayoutLabCitecMovil
CatalogLayoutLabCitecMovil.propTypes = {
    error: PropTypes.any,
    getLabAreas: PropTypes.func,
    getLabTypes: PropTypes.func
}